import Link from "next/link";
import { isWebview, clickHomeButtonNative } from "@utils/webview.util";
import { useEffect } from "react";
import { useRouter } from "next/router";

const NotFoundPage = () => {
  const router = useRouter();

  useEffect(() => {
    const timer = setTimeout(() => {
      router.push("/");
    }, 5000);

    return () => clearTimeout(timer);
  }, [router]);
  return (
    <section className="notfound-section">
      <div className="container-fluid">
        <div className="content">
          <div className="row">
            <div className="col-12 mt-5">
              <div className="bg-white p-3 p-md-4 rounded-2">
                <div className="row">
                  <div className="col-12 my-2 text-center">
                    <img
                      src="/assets/images/icon-404.png"
                      className="icon-notfound mt-4 mb-4"
                      alt="404 Not Found"
                    />
                    <p className="m-0">ขออภัย ไม่พบหน้าที่คุณต้องการ</p>
                    <Link href="/">
                      <a
                        className="btn btn-red2 mt-5 mb-4"
                        onClick={(e) => {
                          if (isWebview()) {
                            e.preventDefault();
                            clickHomeButtonNative();
                          }
                        }}
                      >
                        กลับไปที่หน้าหลัก
                      </a>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NotFoundPage;
